import { useEffect } from 'react';

export default function useHideScroll() {
  useEffect(() => {
    // adding position is fixed to hidden scroll body
    document.body.style.position = 'fixed';

    return () => {
      // remove style position when component unmount
      document.body.style.removeProperty('position');
    };
  }, []);
}
